import { billingPaymentMethodsUrl } from "@app/routes";
import { useNavigate } from "react-router-dom";
import { Group, TitleBar } from "../shared";
import { AddPaymentMethodBlock, StripeProvider } from "./billing-method";

export const BillingAddCreditCardPage = () => {
  const navigate = useNavigate();

  return (
    <StripeProvider>
      <Group>
        <TitleBar description="Add a new credit card to your account">
          Add Credit Card
        </TitleBar>
        <AddPaymentMethodBlock
          onSuccess={() => navigate(billingPaymentMethodsUrl())}
        />
      </Group>
    </StripeProvider>
  );
};
